const WEBSITE_HELP_BASE_URL = 'https://help.nexmo.com';
const API_STATUS_MAPPER = {
  none: 'All operational',
  minor: 'Degraded performance',
  maintenance: 'Partial outage',
  major: 'Partial outage',
  critical: 'Mayor outage',
};

const FOUR_WEEKS_UNIX_TIME = 27 * 24 * 60 * 60 * 1000;

const WEBSITE_REGEX = '^(?=.{1,100}$)https?:\\/\\/(www\\.)?[a-zA-Z0-9\\-\\.]{1,256}\\.[a-zA-Z0-9\\-]{1,9}\\b(?:[\\-a-zA-Z0-9\\(\\)@:%_\\+\\.~#?&\\/=]*)$';
const STATE_REGEX = '^(([Aa][EeLlKkSsZzRr])|([Cc][AaOoTt])|([Dd][EeCc])|([Ff][MmLl])|([Gg][AaUu])|([Hh][Ii])|([Ii][DdLlNnAa])|([Kk][SsYy])|([Ll][Aa])|([Mm][EeHhDdAaIiNnSsOoTt])|([Nn][EeVvHhJjMmYyCcDd])|([Mm][Pp])|([Oo][HhKkRr])|([Pp][WwAaRr])|([Rr][Ii])|([Ss][CcDd])|([Tt][NnXx])|([Uu][Tt])|([Vv][TtIiAa])|([Ww][AaVvIiYy]))$';
const EMAIL_REGEX = '^([a-zA-Z0-9!#$%&\'*+\\/=?^_`\\{\\|\\}~\\-]+(?:\\.[a-zA-Z0-9!#$%&\'*+\\/=?^_`\\{\\|\\}~\\-]+)*@(?:[a-zA-Z0-9](?:[a-z0-9\\-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\\-]*[a-zA-Z0-9])?)$';
const VALID_VERIFICATION_EMAIL_REGEX = '^(?!.*(accounting|accounts|admin|billing|bookings|careers|contact|customerservice|feedback|finance|general|hello|help|helpdesk|hr|info|inquiries|it|jobs|legal|marketing|media|noreply|office|orders|press|purchasing|reservations|sales|service|support|team|tech|webmaster)@).*$';
const E164_PHONE_REGEX = '^1[0-9]{10}$';
const EIN_REGEX = '^[0-9]\\d{8}$';
const ZIP_REGEX = '^[0-9]\\d{4}$';
const CANADA_TAX_ID_REGEX = '^\\d{9}$';
const CANADA_ZIP_REGEX = '^[A-Z][0-9][A-Z] {0,1}[0-9][A-Z][0-9]$';
const OPT_IN_REGEX = '^[a-zA-Z]+$';
const OPT_IN_MESSAGE_REGEX = '^.{20,255}$';

const ARE_WEBSITE_LINKS_REQUIRED = false;

const SHOW_OPT_IN_MESSAGE = false;

const LOW_VOLUME = "LOW_VOLUME"

const TERMINATED = "TERMINATED"

const TERMINATED_EXPLANATION_NOT_FOUND = "No TERMINATED status found.Status change explanation does not receive from Vonage API despite the campaign being terminated. Please contact the Vonage API team for more information."

const IMPLIED_CONSENT_DESCRIBE = "Implied consent in SMS messaging is when a consumer initiates a conversation with a company, usually by texting a question or asking for information. This implies consent to respond with relevant information, but it doesn't mean that the company can text the consumer whenever they want. No marketing or promotional messaging"

const TEXT_TO_JOIN_DESCRIBE = "When customers opt out, they are informed that they can re-subscribe by texting 'JOIN.'"

export {
    WEBSITE_HELP_BASE_URL,API_STATUS_MAPPER,
    WEBSITE_REGEX,
    STATE_REGEX,
    EMAIL_REGEX,
    VALID_VERIFICATION_EMAIL_REGEX,
    E164_PHONE_REGEX,
    EIN_REGEX,
    ZIP_REGEX,
    CANADA_TAX_ID_REGEX,
    OPT_IN_REGEX,
    CANADA_ZIP_REGEX,
    OPT_IN_MESSAGE_REGEX,
    ARE_WEBSITE_LINKS_REQUIRED,
    FOUR_WEEKS_UNIX_TIME,
    LOW_VOLUME,
    TERMINATED,
    TERMINATED_EXPLANATION_NOT_FOUND,
    SHOW_OPT_IN_MESSAGE,
    IMPLIED_CONSENT_DESCRIBE,
    TEXT_TO_JOIN_DESCRIBE
};
